import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Plus_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 4C20.5523 4 21 4.44772 21 5V19L35 19C35.5523 19 36 19.4477 36 20C36 20.5523 35.5523 21 35 21H21V35C21 35.5523 20.5523 36 20 36C19.4477 36 19 35.5523 19 35V21L5 21C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19L19 19V5C19 4.44772 19.4477 4 20 4Z"
            />
        </SvgStyled>
    );
};

export default Plus_xl;
